import {DataStatus, Form, FormField} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useGetManufacturersQuery} from '@dms/api/core';
import {useGetSuppliersQuery} from '@dms/api/warehouse';
import {i18n} from '@dms/i18n';
import {getOptionsFromManufacturers, getOptionsFromSuppliers} from '@dms/shared';

import {suffixTestId, TestIdProps} from 'shared/web';

import {FormToDataGridConnectorProps} from 'features/eag-grid';

type MaterialWarehouseTabExternalFiltersForm = Partial<{
  catalogNumber: string;
  manufacturerId: string;
  supplierId: string;
  isAvailable: boolean;
  isInStock: boolean;
  isOnlyReplenishment: boolean;
}>;

type MaterialWarehouseTabExternalFiltersProps = FormToDataGridConnectorProps & TestIdProps;

export function MaterialWarehouseTabExternalFilters(
  props: MaterialWarehouseTabExternalFiltersProps
) {
  const {
    data: manufacturers,
    isLoading: isManufacturersLoading,
    isError: isManufacturersError,
  } = useGetManufacturersQuery();

  const {
    data: suppliers,
    isLoading: areSuppliersLoading,
    isError: isSuppliersError,
  } = useGetSuppliersQuery();

  const isLoading = isManufacturersLoading || areSuppliersLoading;
  const isError = isManufacturersError || isSuppliersError;

  const values: MaterialWarehouseTabExternalFiltersForm = {
    ...props.values,
  };

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <Form<MaterialWarehouseTabExternalFiltersForm>
        values={values}
        defaultValues={{}}
        onChange={props.onChange}
      >
        {(control) => (
          <VStack spacing={4}>
            <FormField
              control={control}
              name="catalogNumber"
              type="text"
              label={i18n.t('entity.warehouse.labels.catalogueNumber')}
              data-testid={suffixTestId('catalogueNumber', props)}
            />
            <FormField
              control={control}
              name="manufacturerId"
              type="multiChoice"
              label={i18n.t('entity.warehouse.labels.manufacturer')}
              options={getOptionsFromManufacturers(manufacturers)}
              data-testid={suffixTestId('manufacturer', props)}
            />
            <FormField
              control={control}
              name="supplierId"
              type="multiChoice"
              label={i18n.t('entity.warehouse.labels.supplier')}
              options={getOptionsFromSuppliers(suppliers)}
              data-testid={suffixTestId('supplier', props)}
            />
            <FormField
              control={control}
              name="isAvailable"
              label={i18n.t('entity.warehouse.labels.availableOnly')}
              type="checkbox"
              data-testid={suffixTestId('availableOnly', props)}
            />
            <FormField
              control={control}
              name="isInStock"
              label={i18n.t('entity.warehouse.labels.inStock')}
              type="checkbox"
              data-testid={suffixTestId('inStock', props)}
            />
            <FormField
              control={control}
              name="isOnlyReplenishment"
              label={i18n.t('entity.warehouse.labels.isOnlyReplenishment')}
              type="checkbox"
              data-testid={suffixTestId('isOnlyReplenishment', props)}
            />
          </VStack>
        )}
      </Form>
    </DataStatus>
  );
}
